import { apiCall } from "../utils";
import { RESEARCH_API, RESEARCH_TYPE } from "../constants";

import { userActions, formActions } from ".";
const { notification } = userActions;

export const researchActions = {
  getAllResearch,
  getResearchByProfileId,
  insertResearch,
  updateResearch,
  deleteResearch,
  updateResearchAccepted,
  linkResearchToForm,
};

// Nối 1 bài báo vào hồ sơ (application_form) ngay sau khi Thêm - không đợi
// ứng viên bấm Lưu bản nháp. Chỉ thêm 1 liên kết, không đụng các liên kết
// khác của hồ sơ (khác hẳn Lưu bản nháp - xoá hết rồi tạo lại toàn bộ).
// Chạy ngầm, không cần thông báo lỗi ồn ào - nếu lỗi, bấm Lưu bản nháp vẫn
// nối được như trước.
function linkResearchToForm(applicationFormId, scientificResearchId) {
  return async () => {
    if (!applicationFormId || !scientificResearchId) return false;

    const api = RESEARCH_API.linkResearchToForm();
    const { response, error } = await apiCall({
      ...api,
      payload: { applicationFormId, id: scientificResearchId },
    });

    return !error && response?.status === 200 && response?.data?.success;
  };
}

function getAllResearch() {
  return async (dispatch) => {
    dispatch(loading());

    const api = RESEARCH_API.getAllResearch();
    const { response, error } = await apiCall({ ...api });

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));
      // dispatch(notification({ message: 'Lấy bài báo khoa học thành công', type: 'success' }));
    } else {
      dispatch(failure(error));
      dispatch(
        notification({
          message: "Lấy bài báo khoa học thất bại",
          type: "error",
        })
      );
    }
  };

  function loading() {
    return { type: RESEARCH_TYPE.GET_ALL_RESEARCH_LOADING };
  }
  function success(payload) {
    return { type: RESEARCH_TYPE.GET_ALL_RESEARCH_SUCCESS, payload };
  }
  function failure(error) {
    return { type: RESEARCH_TYPE.GET_ALL_RESEARCH_FAILURE, error };
  }
}

function getResearchByProfileId(id) {
  return async (dispatch) => {
    dispatch(loading());

    const api = RESEARCH_API.getResearchByProfileId(id);
    const { response, error } = await apiCall({ ...api });

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));
      // dispatch(notification({ message: 'Lấy bài báo khoa học thành công', type: 'success' }));
    } else {
      dispatch(failure(error));
      dispatch(
        notification({
          message: "Lấy bài báo khoa học thất bại",
          type: "error",
        })
      );
    }
  };

  function loading() {
    return { type: RESEARCH_TYPE.GET_RESEARCH_BY_PROFILE_ID_LOADING };
  }
  function success(payload) {
    return { type: RESEARCH_TYPE.GET_RESEARCH_BY_PROFILE_ID_SUCCESS, payload };
  }
  function failure(error) {
    return { type: RESEARCH_TYPE.GET_RESEARCH_BY_PROFILE_ID_FAILURE, error };
  }
}

function insertResearch(payload) {
  return async (dispatch) => {
    dispatch(loading());

    const api = RESEARCH_API.insertResearch();
    const { response, error } = await apiCall({
      ...api,
      payload: payload.map((e) => ({
        ...e,
        publishYear: String(e.publishYear),
      })),
    });

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data[0]));
      dispatch(
        notification({
          message: "Thêm bài báo khoa học thành công",
          type: "success",
        })
      );
      return response.data.data[0];
    } else {
      dispatch(failure(error));
      dispatch(
        notification({
          message: "Thêm bài báo khoa học thất bại",
          type: "error",
        })
      );
      return null;
    }
  };

  function loading() {
    return { type: RESEARCH_TYPE.INSERT_RESEARCH_LOADING };
  }
  function success(payload) {
    return { type: RESEARCH_TYPE.INSERT_RESEARCH_SUCCESS, payload };
  }
  function failure(error) {
    return { type: RESEARCH_TYPE.INSERT_RESEARCH_FAILURE, error };
  }
}

function updateResearch(payload) {
  return async (dispatch) => {
    dispatch(loading());

    const api = RESEARCH_API.updateResearch();
    const { response, error } = await apiCall({ ...api, payload });

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));
      // dispatch(formActions.updateFocusFormByData('formScientificResearch', 'scientificResearch', response.data.data));
      dispatch(
        notification({
          message: "Chỉnh sửa bài báo khoa học thành công",
          type: "success",
        })
      );
    } else {
      dispatch(failure(error));
      dispatch(
        notification({
          message: "Chỉnh sửa bài báo khoa học thất bại",
          type: "error",
        })
      );
    }
  };

  function loading() {
    return { type: RESEARCH_TYPE.UPDATE_RESEARCH_LOADING };
  }
  function success(payload) {
    return { type: RESEARCH_TYPE.UPDATE_RESEARCH_SUCCESS, payload };
  }
  function failure(error) {
    return { type: RESEARCH_TYPE.UPDATE_RESEARCH_FAILURE, error };
  }
}

function deleteResearch(id) {
  return async (dispatch) => {
    dispatch(loading());

    const api = RESEARCH_API.deleteResearch(id);
    const { response, error } = await apiCall({ ...api });

    if (!error && response.status === 200) {
      dispatch(success(id));
      dispatch(
        notification({
          message: "Xoá bài báo khoa học thành công",
          type: "success",
        })
      );
    } else {
      dispatch(failure(error));
      dispatch(
        notification({
          message: "Xoá bài báo khoa học thất bại",
          type: "error",
        })
      );
    }
  };

  function loading() {
    return { type: RESEARCH_TYPE.DELETE_RESEARCH_LOADING };
  }
  function success(id) {
    return { type: RESEARCH_TYPE.DELETE_RESEARCH_SUCCESS, id };
  }
  function failure(error) {
    return { type: RESEARCH_TYPE.DELETE_RESEARCH_FAILURE, error };
  }
}

function updateResearchAccepted(payload, auto = false) {
  return async (dispatch) => {
    dispatch(loading());

    const api = RESEARCH_API.updateResearchAccepted();
    const { response, error } = await apiCall({ ...api, payload });

    let noti = payload[0]?.accepted ? "Duyệt " : "Huỷ duyệt ";

    if (auto) {
      noti = "Tự động duyệt ";
    }

    if (!error && response.status === 200 && response.data.success) {
      dispatch(success(response.data.data));
      dispatch(
        formActions.updateFocusForm(
          "formScientificResearch",
          response.data.data
        )
      );
      dispatch(
        notification({
          message: `${noti} bài báo khoa học thành công`,
          type: "success",
        })
      );
      return true;
    } else {
      dispatch(failure(error));
      dispatch(
        notification({
          message: `${noti} bài báo khoa học thất bại`,
          type: "error",
        })
      );
    }
  };

  function loading() {
    return { type: RESEARCH_TYPE.UPDATE_RESEARCH_ACCEPTED_LOADING };
  }
  function success(payload) {
    return { type: RESEARCH_TYPE.UPDATE_RESEARCH_ACCEPTED_SUCCESS, payload };
  }
  function failure(error) {
    return { type: RESEARCH_TYPE.UPDATE_RESEARCH_ACCEPTED_FAILURE, error };
  }
}
